module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp23_7005.34312b9c.png";